/**
 *
 * Load Plugins
 * If you don't see a plugin below it might be autloaded via webpack
 * Check webpack.mix.js for autoloaded plugins.
 *
 */
 require('@fancyapps/fancybox');
 // require('./fontawesome');

const VimeoPlayer = require('@vimeo/player');

import { Foundation } from './foundation';
import { WOW } from 'wowjs';
Foundation.addToJquery(jQuery);

/**
 *
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 *
 */
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 *
 * Application script
 *
 */
$(function() {
    $(document).foundation();

    // Image tile accordions
    // $('.image-tile--accordion').off('click');

    if (!Foundation.MediaQuery.atLeast('large')) {
        $('.image-tile__title').on('click', function(e) {
            e.preventDefault();
            let item = $(this).parent('.image-tile--accordion');
            $(item).toggleClass('is-active');
            $(item).find('.image-tile__content').slideToggle();
        });
    }

    if (!Foundation.MediaQuery.atLeast('large')) {
        $('.icon-tile__title').on('click', function(e) {
            e.preventDefault();
            let item = $(this).parent('.icon-tile--accordion');
            $(item).toggleClass('is-active');
            $(item).find('.icon-tile__content').slideToggle();
        });
    }

    // Load Google map javascript
    if(document.querySelector('[data-maps-api-key]') && !document.querySelector('.gMapsAPI')){
        if($('[data-maps-api-key]').length){
            let script = document.createElement('script');
            const apiKey = $('[data-maps-api-key]:first').attr('data-maps-api-key');
            script.type = 'text/javascript';
            script.src = 'https://maps.googleapis.com/maps/api/js?key=' + apiKey + '&callback=initializeMaps';
            script.className = 'gMapsAPI';
            document.body.appendChild(script);
        }
    }

    // Switched On pop up message
    if($('#switched-on-popup').length > 0){
        $('#switched-on-popup').foundation('open');
    }

    // Same size package boxes
    if($('.package-overview').length > 0){
        $('.package-overview').matchHeight();
    }

    // Banner Slideshow
    if($('.banner--slick').length > 0) {
        $('.banner--slick').slick({
            autoplay: true,
            autoplaySpeed: 5000,
            speed: 800,
            infinite: true,
            slidesToShow: 1,
            arrows: true,
            prevArrow: '<span class="ui-arrow ui-arrow--prev"></span>',
            nextArrow: '<span class="ui-arrow ui-arrow--next"></span>',
            fade: true,
        });
    }

    // Gallery Slideshow
    if($('.gallery-slideshow__inner').length > 0) {
        var $status = $('.gallery-slideshow__pagination'),
            $slickElement = $('.gallery-slideshow__inner'),
            totalSlides,
            slidePosition,
            $currentImage = $('.gallery-slideshow .slick-current img');


        $('.gallery-slideshow__slide').each(function() {
            var currentImage = $(this).children('.gallery-slideshow__image'),
                imageWidth = $(currentImage).width(),
                imageText = $(this).children('.gallery-slideshow__text');
            $(imageText).width(imageWidth);
        });

        $slickElement.slick({
            infinite: true,
            slidesToShow: 1,
            centerMode: true,
            variableWidth: true,
            arrows: true,
            prevArrow: '<span class="ui-arrow ui-arrow--prev"></span>',
            nextArrow: '<span class="ui-arrow ui-arrow--next"></span>',
            speed: 800
        });
    };


    // Gallery Carousel
    $('.gallery-carousel__slides').slick({
        lazyLoad: 'ondemand',
        setPosition: 0,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        infinite: true,
        prevArrow: '<span class="ui-arrow ui-arrow--prev"></span>',
        nextArrow: '<span class="ui-arrow ui-arrow--next"></span>',
        asNavFor: '.gallery-carousel__thumbs'
    });

    $('.gallery-carousel__thumbs').slick({
        lazyLoad: 'ondemand',
        setPosition: 0,
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.gallery-carousel__images',
        centerMode: true,
        focusOnSelect: true,
        infinite: true,
        centerPadding: 0,
        arrows: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 740,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 420,
                settings: {
                    slidesToShow: 2
                }
            }
        ]
    });

    /*
        wowjs
    */
    var wow = new WOW(
        {
            boxClass:     'wow',            // animated element css class (default is wow)
            animateClass: 'is-animating',   // animation css class (default is animated)
            offset:       0,                // distance to the element when triggering the animation (default is 0)
            mobile:       true,             // trigger animations on mobile devices (default is true)
            live:         true,             // act on asynchronously loaded content (default is true)
            callback:     function(box) {
            // the callback is fired every time an animation is started
            // the argument that is passed in is the DOM node being animated
            },
            scrollContainer: null // optional scroll container selector, otherwise use window
        }
    );
    wow.init();
    $('.mh').matchHeight({
        byRow: true
    });

    /*
    *   Cookie finder
    */
    function getCookie(name) {
        var value = "; " + document.cookie,
            parts = value.split("; " + name + "=");
        if (parts.length == 2){
            return parts.pop().split(";").shift();
        }
    }

    /*
    *   RENOVATION BUILDER
    */
    if($('.renovation-page-holder').length > 0){
        // Initiate parsley
        $('body').on('submit', '#Form_NewCustomerForm', function(event){
            event.preventDefault();
            event.stopImmediatePropagation();

            if($(this).parsley().isValid()){
                $.ajax({
                    url : $(this).attr('action'),
                    data : $(this).serialize(),
                    type : 'POST',
                    success:function(data){
                        data = JSON.parse(data);
                        $('#new-customer-modal').foundation('close');

                        showLoader();

                        // Update customer info into the form
                        if(data.Customer){
                            $('#Form_RequestConsultationForm_FirstName').val(data.Customer.FirstName);
                            $('#Form_RequestConsultationForm_Surname').val(data.Customer.Surname);
                            $('#Form_RequestConsultationForm_Email').val(data.Customer.Email);
                            $('#Form_RequestConsultationForm_PhoneNumber').val(data.Customer.PhoneNumber);
                            $('#Form_RequestConsultationForm_City').val(data.Customer.City);
                        }

                        // Update options
                        var element;
                        $('.areaoption-radio:checked').each(function(e){
                            element = $(this);
                            // Add class to selection and remove others
                            element.closest('.grid-x').find('.renovation-option-value').removeClass('selected');
                            element.closest('.renovation-option-value').addClass('selected');
                        });

                        // Update pricing accordingly
                        updateSectionPricing(element);
                        updateTotalPricing();

                        hideLoader();

                        // Save update
                        SaveProjectArea(element);
                    }
                });
            }
        });

        // Stop the reno form submitting by default
        $('body').on('submit', '#renovation-form', function(event){
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
        });

        // Global money convertor
        var MoneyFormat = function(value){
            var num = '$' + value.toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"); // With decimals hidden
                // num = '$' + value.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"); // With 2 decimals shown

            return num;
        };

        // Show the loading overlay
        var showLoader = function(){
            $('.loading').show().animate({'opacity' : 1}, 500);
        };
        // Hide the loading overlay
        var hideLoader = function(){
            $('.loading').animate({'opacity' : 0}, 500, function(){
                $(this).hide();
            });
        };

        // Hide edit buttons for area sections
        var hideEditButton = function(){
            $('.renovation-area-accordion.open').each(function(e){
                $(this).closest('.renovation-area').find('.renovation-section-edit').hide();
            });
        };
        hideEditButton();

        // Hide the currently open section - elm should always be '.renovation-area'
        var closeSection = function(elm){
            var acordHolder = elm.find('.renovation-area-accordion').first();
            elm.find('.renovation-section-edit').show();

            acordHolder.animate({'height' : 0, 'opacity' : 0}, 500).removeClass('open').addClass('closed');
        };

        // Open the selected section - elm should always be '.renovation-area'
        var openSection = function(elm){
            var acordHolder = elm.find('.renovation-area-accordion').first(),
                newHeight = acordHolder.find('.renovation-area-main').outerHeight() + acordHolder.find('.renovation-area-titlebar').outerHeight();

            // Close currently open ones
            $('.renovation-area-accordion.open').each(function(e){
                if(!$(this).closest('.renovation-area').is(elm)){
                    closeSection($(this).closest('.renovation-area'));
                }
            });

            // Show bottom buttons if not already
            if(elm.find('.renovation-area-budgets-holder').length < 1){
                $('.renovation-actionbar').removeClass('hide').addClass('show');
            }

            // Close the consultation form if not already
            $('.renovation-consultation-form').addClass('opacityHide');

            acordHolder.animate({'height' : newHeight, 'opacity' : 1}, 500, function(){
                $(this).removeClass('closed').addClass('open').height('auto');
                hideEditButton();
                // Scroll to the open element
                $('body').scrollTo(elm, 500);
            });
        };

        $('body').on('click', '.renovation-section-edit', function(e){
            var areaHolder = $(this).closest('.renovation-area'),
                acordHolder = areaHolder.find('.renovation-area-accordion').first();

                $(this).hide();
                openSection(areaHolder);
        });

        // Update section pricing
        var updateSectionPricing = function(elm){
            var areaParent = elm.closest('.renovation-area'),
                optionPrice = 0,
                optionLowPrice = optionPrice,
                optionHighPrice = optionPrice,
                lowPrice = parseFloat(areaParent.find('.renovation-section-price-base-low').first().val()),
                highPrice = parseFloat(areaParent.find('.renovation-section-price-base-high').first().val()),
                optionID = null;

            areaParent.find('.areaoption-radio:checked').each(function(e){
                if($(this).val() != 'none'){
                    optionID = $(this).attr('id').replace('areaoption-val-', '');
                    optionPrice = parseFloat($('#areaoption-price-' + optionID).val());
                } else {
                    optionPrice = 0;
                }
                optionLowPrice += optionPrice;
                optionHighPrice += (optionPrice * 1.2); // add 20%
            });

            // Calculate new pricing
            lowPrice += optionLowPrice;
            highPrice += optionHighPrice;

            // Update values
            areaParent.find('.renovation-section-price-low').html(MoneyFormat(lowPrice));
            areaParent.find('.renovation-section-price-high').html(MoneyFormat(highPrice));
            areaParent.find('.renovation-section-price-total-low').val(lowPrice);
            areaParent.find('.renovation-section-price-total-high').val(highPrice);
        };

        // Update the total pricing area
        var updateTotalPricing = function(){
            var low = 0,
                high = 0;

            // Add up the low values
            $('.renovation-section-price-total-low').each(function(){
                low += parseInt($(this).val());
            });

            // Add up the high values
            $('.renovation-section-price-total-high').each(function(){
                high += parseInt($(this).val());
            });

            // Add them to the temlate
            $('.renovation-total-price-low').html(MoneyFormat(low));
            $('.renovation-total-price-high').html(MoneyFormat(high));

            // Show the bar
            $('.renovation-totalbar, .renovation-actionbar').removeClass('hide').addClass('show');
        };

        // Show small loader
        var ShowSmallLoader = function(){
            $('.small-loader').addClass('show');
        };

        // Hide small loader
        var HideSmallLoader = function(){
            $('.small-loader').removeClass('show');
        };

        // Save project area
        var SaveProjectArea = function(elm){
            var areaParent = elm.closest('.renovation-area'),
                url = areaParent.data('update'),
                formData = areaParent.find('.areaoption-radio, .area-additional-notes').serializeArray();

            ShowSmallLoader();
            $.post(url, JSON.stringify(formData), function(data){
                HideSmallLoader();
            });
        };

        // Return new areas
        $('body').on('click', '.renovation-area-button', function(e){
            // Check if this area can be customised
            if($(this).hasClass('renovation-area-available')){
                e.stopPropagation();
                e.preventDefault();

                var url = $(this).attr('href');

                showLoader();
                $.post(url, '', function(data){
                    // Check if first one
                    if($('.renovation-area').length < 1){
                        // Replace whole content block
                        $('.renovation-page-holder').html(data);
                        $('body').scrollTo($('.renovation-area').last(), 500);
                        hideEditButton();
                    } else {
                        // Close the pop up if it exists
                        $('#additional-room').find('.close-button').click();
                        // Append to the end of the list
                        $(data).insertBefore('.renovation-totalbar');
                        openSection($('.renovation-area').last());
                    }

                    hideLoader();

                    // Re init foundation
                    setTimeout(function(){
                        $(document).foundation();
                    }, 500);
                });
            } else {
                openSection($('.renovation-area').last());
            }
        });

        // Update the square metres based on width / depth
        $('body').on('change', '.area-width, .area-depth', function(e){
            e.preventDefault();

            var contentHolder = $(this).closest('.renovation-area-field-holder'),
                newSquareMetre = 0,
                width = contentHolder.find('.area-width').first().val(),
                depth = contentHolder.find('.area-depth').first().val();

            // Calc size and update
            newSquareMetre = (width * depth);
            contentHolder.find('.area-squaremetre').first().val(newSquareMetre);
        });

        // Fire button on square meterage update
        $('body').on('change', '.area-squaremetre, .area-perimeter', function(e){
            e.preventDefault();
            var contentHolder = $(this).closest('.renovation-area-field-holder');

            contentHolder.next('.renovation-area-updatebtn').removeClass('hide');
        });

        // Return the ranges for the area
        $('body').on('click', '.renovation-area-updatebtn', function(e){
            e.stopPropagation();
            e.preventDefault();

            var parent = $(this).parent(),
                urlField = parent.find('.renovation-area-url').first(),
                squareMetreField = parent.find('.area-squaremetre').first(),
                perimeterField = parent.find('.area-perimeter').first(),
                contentHolder = $(this).closest('.renovation-overview-area'),
                url = '';

            // Check square metre has value
            if(squareMetreField.val() > 0){
                var perimeterSize = perimeterField ? perimeterField.val() : 0;

                url = urlField.val() + '/' + squareMetreField.val() + '/' + perimeterSize;
                showLoader();

                $.post(url, '', function(data){
                    contentHolder.find('.renovation-area-budgets-holder').remove();
                    contentHolder.append(data);
                    // Resize the height of the container
                    //openSection(contentHolder.closest('.renovation-area'));
                    // Scroll to the open element
                    $('body').scrollTo(contentHolder.find('.renovation-area-budgets-holder').first(), 500);

                    hideLoader();
                    // Re init foundation
                    setTimeout(function(){
                        $(document).foundation();
                        // Same size area level boxes
                        if($('.renovation-area-level-content').length > 0){
                            $('.renovation-area-level-content').matchHeight();
                        }
                    }, 500);
                });
            }
        });

        // Return the options available
        $('body').on('click', '.renovation-area-level-btn', function(e){
            e.stopPropagation();
            e.preventDefault();

            var url = $(this).attr('href'),
                areaParent = $(this).closest('.renovation-area'),
                areaHolder = $(this).closest('.renovation-area-main');

            showLoader();
            $.post(url, '', function(data){
                data = JSON.parse(data);
                // Check for the pricing information and populate
                if(data.PriceLow && data.PriceHigh){
                    areaParent.find('.renovation-section-price-low').html(MoneyFormat(data.PriceLow));
                    areaParent.find('.renovation-section-price-high').html(MoneyFormat(data.PriceHigh));
                    areaParent.find('.renovation-section-price-total-low').val(data.PriceLow);
                    areaParent.find('.renovation-section-price-total-high').val(data.PriceHigh);
                    // Show the fields
                    areaParent.find('.renovation-section-price, .renovation-area-bottomtitlebar, .renovation-actionbar').removeClass('hide').addClass('show');
                }
                if(data.PriceBaseLow && data.PriceBaseHigh){
                    areaParent.find('.renovation-section-price-base-low').val(data.PriceBaseLow);
                    areaParent.find('.renovation-section-price-base-high').val(data.PriceBaseHigh);
                }

                // Add the template to the section
                areaHolder.html(data.Template);

                // Resize the height of the container
                openSection(areaParent);

                updateTotalPricing();

                hideLoader();

                // Re init foundation
                setTimeout(function(){
                    $(document).foundation();
                }, 1000);
            });
        });

        // On selection of option change
        $('body').on('change', '.areaoption-radio', function(e){
            var element = $(this);

            // Check for customer registration
            if(!getCookie('CustomerID')){
                $('#new-customer-modal').foundation('open');
            } else {
                // Add class to selection and remove others
                element.closest('.grid-x').find('.renovation-option-value').removeClass('selected');

                // Check if checked or unchecked
                if (element.attr('checked')){
                    element.closest('.renovation-option-value').addClass('selected');
                }

                // Update pricing accordingly
                updateSectionPricing(element);
                updateTotalPricing();
                // Save update
                SaveProjectArea(element);
            }
        });
        // dding ability to uncheck the radio field
        $('body').on('click', '.renovation-option-value label', function(e){
            e.stopPropagation();
            e.preventDefault();

            var radioBtn = $('#' + $(this).attr('for'));

            $.each(radioBtn.closest('.grid-x').find('.areaoption-radio'), function(e){
                if($(this).attr('id') != radioBtn.attr('id')){
                    $(this).checked = false;
                    $(this).prop('checked', false);
                    $(this).attr('checked', false);
                }
            });

            if(radioBtn.attr('checked')) {
                radioBtn.checked = false;
                radioBtn.prop('checked', false);
                radioBtn.attr('checked', false);

                // Check the blank option
                radioBtn.closest('.grid-x').find('.areaoption-radio-none').checked = true;
                radioBtn.closest('.grid-x').find('.areaoption-radio-none').prop('checked', true);
                radioBtn.closest('.grid-x').find('.areaoption-radio-none').attr('checked', true);
            } else {
                radioBtn.checked = true;
                radioBtn.prop('checked', true);
                radioBtn.attr('checked', true);
            }

            radioBtn.trigger('change');
        });

        // Update on unfocus of the text area
        $('body').on('blur', '.area-additional-notes', function(e){
            // Check for customer registration
            if(!getCookie('CustomerID')){
                $('#new-customer-modal').foundation('open');
            } else {
                // Save update
                SaveProjectArea($(this));
            }
        });

        // Open up meterage for user to edit
        $('body').on('click', '.area-size-edit', function(e){
            var parent = $(this).closest('.renovation-area-sizeform'),
                formHolder = parent.find('.renovation-area-meterage-holder').first(),
                newHeight = formHolder.find('div').first().outerHeight();

            if(formHolder.height() < 1){
                formHolder.animate({'height' : newHeight}, 400);
            } else {
                formHolder.animate({'height' : 0}, 400);
            }
        });

        // Update project with new size
        $('body').on('click', '.renovation-area-meterage-update', function(e){
            e.preventDefault();

            var sectionHolder = $(this).closest('.renovation-area'),
                meterage = sectionHolder.find('.renovation-area-meterage').first().val(),
                perimeterMeterage = sectionHolder.find('.renovation-area-perimeter').first() ? sectionHolder.find('.renovation-area-perimeter').first().val() : 0,
                url = $(this).attr('href') + '/' + meterage + '/' + perimeterMeterage;

            showLoader();
            $.post(url, '', function(data){
                data = JSON.parse(data);
                // Check for new template
                if(data.Template){
                    sectionHolder.replaceWith(data.Template);
                    $('#section-' + data.AreaID).find('.renovation-section-price, .renovation-area-bottomtitlebar, .renovation-actionbar').removeClass('hide').addClass('show');
                }

                hideLoader();
                // Re init foundation
                setTimeout(function(){
                    $(document).foundation();
                }, 500);
            });
        });

        // Remove current section
        $('body').on('click', '.renovation-section-remove', function(e){
            e.stopPropagation();
            e.preventDefault();

            var url = $(this).attr('href'),
                sectionHolder = $(this).closest('.renovation-area');

            showLoader();
            $.post(url, '', function(data){
                data = JSON.parse(data);
                // Check for new template
                if(data.Template){
                    $('.renovation-page-holder').html(data.Template);
                } else {
                    // Open nearest section
                    openSection(sectionHolder.siblings('.renovation-area').first());
                    // Delete the section
                    sectionHolder.animate({'opacity' : 0, 'height' : 0}, 300, function(){
                        $(this).remove();
                    });
                }

                hideLoader();

                // Time out to allow for updates
                setTimeout(function(){
                    // Update pricing after removal
                    updateTotalPricing();
                    // Re init foundation
                    $(document).foundation();
                }, 500);
            });
        });
    }

    // Request a consoltation button click
    $('body').on('click', '#request-consultation', function(e){
        e.preventDefault();
        var consultationHolder = $('.renovation-consultation-form').first();
        showLoader();

        // Check for multipl option areas
        if($('.renovation-area').length > 1){
            $('.consultation-notification-box').addClass('hide');
        } else {
            $('.consultation-notification-box').removeClass('hide');
        }

        // hide the action bar
        $('.renovation-actionbar').addClass('hide').removeClass('show');
        // Show the consultation form
        consultationHolder.removeClass('opacityHide');

        // Close currently open ones
        $('.renovation-area-accordion.open').each(function(e){
            closeSection($(this).closest('.renovation-area'));
        });

        // Scroll the user to the top of the form
        $('body').scrollTo($('#renovation-form'), 500, function(){
            $('body').scrollTo(consultationHolder, 500, function(){
                hideLoader();
            });
        });
    });
});



// WEBPACK FOOTER //
// ./themes/base/js/app.js